/*
Vertical Navigation with RBAC
*/

import dashboard from './dashboard'
import appsAndPages from './apps-and-pages'

const role = localStorage.getItem('role')
const alwaysVisible = ['Change password']

let navigation = []

/* =====================================================
   SUPER ADMIN → ALL EXCEPT RESTRICTED SCREENS
===================================================== */

if (role === 'super-admin') {

  const superAdminRestrictedScreens = [
    'My Talents',
    'My Talent Scouts',
    'My Talents (Under 18)',
    'My Geo Verse',
    'My Geo Nexus',
    'My Posts',
  ]

  navigation = [
    ...dashboard,
    ...appsAndPages
      .map(item => {
        if (item.children && item.children.length) {

          const filteredChildren = item.children.filter(
            child =>
              !superAdminRestrictedScreens.includes(child.title) ||
              alwaysVisible.includes(child.title)
          )

          const hasAlwaysVisibleChild = item.children.some(c =>
            alwaysVisible.includes(c.title)
          )

          return filteredChildren.length || hasAlwaysVisibleChild
            ? {
                ...item,
                children: filteredChildren.length
                  ? filteredChildren
                  : item.children.filter(c =>
                      alwaysVisible.includes(c.title)
                    ),
              }
            : null
        }

        return superAdminRestrictedScreens.includes(item.title) &&
          !alwaysVisible.includes(item.title)
          ? null
          : item
      })
      .filter(Boolean),
  ]
}

/* =====================================================
   ADMIN → ALL EXCEPT SOME SCREENS
===================================================== */
else if (role === 'admin') {

  const adminRestrictedScreens = [
    'Packages',
    'Advertisement',
    'Terms & Conditions',
    'Privacy Policy',
    'Change password',
    'My Dashboard',
    'My Talents',
    'My Talent Scouts',
    'My Talents (Under 18)',
    'My Geo Verse',
    'My Geo Nexus',
    'My Posts',
    'User Management',
  ]

  navigation = [
    ...dashboard,
    ...appsAndPages
      .map(item => {
        if (item.children && item.children.length) {

          const filteredChildren = item.children.filter(
            child =>
              !adminRestrictedScreens.includes(child.title) ||
              alwaysVisible.includes(child.title)
          )

          const hasAlwaysVisibleChild = item.children.some(c =>
            alwaysVisible.includes(c.title)
          )

          return filteredChildren.length || hasAlwaysVisibleChild
            ? {
                ...item,
                children: filteredChildren.length
                  ? filteredChildren
                  : item.children.filter(c =>
                      alwaysVisible.includes(c.title)
                    ),
              }
            : null
        }

        return adminRestrictedScreens.includes(item.title) &&
          !alwaysVisible.includes(item.title)
          ? null
          : item
      })
      .filter(Boolean),
  ]
}

/* =====================================================
   MEMBER → RESTRICTED SCREENS HIDDEN
===================================================== */
else if (role === 'member') {

  const memberRestrictedScreens = [
    'Push Notifications',
    'Talent (Under 18)',
    'Packages',
    'Advertisement',
    'Reports',
    'Analysis Reports',
    'Referrals',
    'Terms & Conditions',
    'Privacy Policy',
    'Change password',
    'My Dashboard',
    'My Talents',
    'My Talent Scouts',
    'My Talents (Under 18)',
    'My Geo Verse',
    'My Geo Nexus',
    'My Posts',
    'User Management',
  ]

  const allowedScreens = appsAndPages
    .map(item => {
      if (item.children && item.children.length) {

        const filteredChildren = item.children.filter(
          child =>
            !memberRestrictedScreens.includes(child.title) ||
            alwaysVisible.includes(child.title)
        )

        const hasAlwaysVisibleChild = item.children.some(c =>
          alwaysVisible.includes(c.title)
        )

        return filteredChildren.length || hasAlwaysVisibleChild
          ? {
              ...item,
              children: filteredChildren.length
                ? filteredChildren
                : item.children.filter(c =>
                    alwaysVisible.includes(c.title)
                  ),
            }
          : null
      }

      return memberRestrictedScreens.includes(item.title) &&
        !alwaysVisible.includes(item.title)
        ? null
        : item
    })
    .filter(Boolean)

  navigation = [
    ...dashboard,
    ...allowedScreens,
  ]
}

/* =====================================================
   COORDINATOR → TALENT SCREENS ONLY
===================================================== */
else if (role === 'coordinator') {

  const talentScreens = [
    'My Dashboard',
    'Teams',
    'My Talents',
    'My Talents (Under 18)',
    'My Talent Scouts',
    'My Geo Verse',
    'My Geo Nexus',
    'My Posts',
    'Reports',
  ]

  navigation = [
    ...dashboard,
    ...appsAndPages
      .map(item => {
        if (item.children && item.children.length) {
          const filteredChildren = item.children.filter(child =>
            talentScreens.includes(child.title)
          )
          return filteredChildren.length
            ? { ...item, children: filteredChildren }
            : null
        }

        return talentScreens.includes(item.title) ? item : null
      })
      .filter(Boolean),
  ]
}

/* =====================================================
   FALLBACK → NOT LOGGED IN
===================================================== */
else {
  navigation = []
}

export default navigation